var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.isAllowed
    ? _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c(
            "w-card-title",
            [
              _vm._v(" " + _vm._s(_vm.$ct("titles.import-contacts"))),
              _c("w-spacer"),
              _c(
                "w-link",
                {
                  attrs: { white: "" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-content",
            [_c("app-missing-module", { attrs: { "module-id": "0" } })],
            1
          ),
        ],
        1
      )
    : _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [
            _vm._v(_vm._s(_vm.$ct("titles.import-contacts"))),
          ]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      !_vm.file
                        ? _c("app-file-upload", {
                            attrs: {
                              sending: _vm.uploading,
                              label: _vm.$ct("labels.drop-csv"),
                              "allowed-extensions": _vm.allowedExtensions,
                            },
                            on: {
                              input: function ($event) {
                                _vm.file = $event
                              },
                            },
                          })
                        : _c(
                            "p",
                            [
                              _vm._v(" " + _vm._s(_vm.file.name) + " "),
                              _c(
                                "w-button",
                                {
                                  attrs: { flat: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.file = null
                                    },
                                  },
                                },
                                [_c("w-fa", { attrs: { icon: "times" } })],
                                1
                              ),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("div", { staticClass: "label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$ct(
                              "csv-import-existing-contact-handling-label"
                            )
                          )
                        ),
                      ]),
                      _vm._l(_vm.existingContactHandlingItems, function (item) {
                        return _c("w-radio", {
                          key: item.value,
                          attrs: {
                            checked: _vm.existingContactHandling == item.value,
                            label: item.text,
                            disabled: item.disabled,
                          },
                          on: {
                            input: function ($event) {
                              _vm.existingContactHandling = item.value
                            },
                          },
                        })
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { disabled: _vm.uploading, icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { disabled: _vm.file == null, icon: "check" },
                  on: {
                    click: function ($event) {
                      return _vm.upload()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("common.confirm")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }